import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    DestroyRef,
    ElementRef,
    HostBinding,
    Input,
    OnChanges,
    Renderer2,
    ViewChild,
    inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { Observable } from 'rxjs';

@Component({
    selector: 'ms-progress-bar',
    templateUrl: './progress-bar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent implements OnChanges, AfterViewInit {
    private readonly destroyRef = inject(DestroyRef);

    @HostBinding('class.ms-progress-bar') cssClass = true;

    @Input() shouldShowInformation = false;
    @Input() shouldShowPercentage = true;
    @Input() smoothProgressTransition = false;
    @Input() animationDuration!: number;
    @Input() informationText: string | undefined;
    @Input() value!: Observable<number>;

    @ViewChild('percentage', { static: false }) percentage!: ElementRef;
    @ViewChild('progress', { static: true }) progress!: ElementRef;

    constructor(private renderer: Renderer2) {}

    ngAfterViewInit(): void {
        this.value.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((v) => {
            if (this.shouldShowPercentage && this.percentage) {
                this.renderer.setProperty(this.percentage.nativeElement, 'innerHTML', `${v}%`);
            }

            this.renderer.setStyle(this.progress.nativeElement, 'width', `${v}%`);
        });
    }

    ngOnChanges(changes: ISimpleChanges<ProgressBarComponent>): void {
        if ((changes.smoothProgressTransition || changes.animationDuration) && this.smoothProgressTransition) {
            this.setProgressBarTransition(this.animationDuration);
        }
    }

    private setProgressBarTransition(animationDuration: number): void {
        this.renderer.setStyle(this.progress.nativeElement, 'transition', `width ${animationDuration}ms linear`);
    }
}
